import React from 'react';
import { Button, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import AddStudentPause from './AddStudentPause';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class StudentPauseStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataActive: [],
            dataPast: [],

            newDate: new Date(),
            newDocumentNumber: '',
            newReason: '',
            newComment: '',
            newId: null,
            newOptLock: null,

            showAddForm: false,
            showEditForm: false
        };
        this.onRemoveStudentPause = this.onRemoveStudentPause.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
    }

    componentDidMount() {
        this.updateStatus();
    }

    updateStatus() {
        this.setState({ loader: true });
        axios.get(`/student-pause/student-study-program/${this.props.studentStudyProgramId}/`)
            .then(res => {
                const dataActive = res.data;
                this.setState({ dataActive, loader: false });
                this.props.updateStudentStatuses();
            })
            .catch(err => {
                console.log('Failed to fetch semesters.');
            });
    }

    onRemoveStudentPause(id) {
        this.setState({ loader: true });
        axios.delete(`student-pause/${id}/`)
            .then(res => {
                this.setState({ loader: false });
                this.updateStatus();
            })
            .then(res => {
                toast('Status mirovanja je uspješno izbrisan.');
            })
            .catch(err => {
                toast('Došlo je do greške.');
            });
    }

    render() {
        return (
            <div>

                {this.state.showAddForm && <AddStudentPause
                    studentStudyProgramId={this.props.studentStudyProgramId}
                    updateStatus={this.updateStatus}
                    togglePauseVisibility={this.props.togglePauseVisibility}
                    closeForm={() => this.setState({ showAddForm: false })}
                />}
                {this.state.showEditForm && <AddStudentPause
                    edit
                    studentStudyProgramId={this.props.studentStudyProgramId}
                    updateStatus={() => this.updateStatus()}
                    closeForm={() => this.setState({ showEditForm: false })}
                />}

                { (!this.state.showAddForm && !this.state.showEditForm) && !this.props.locked &&
                <div>

                    <Header style={IconHeader} floated="right" >
                        <Button
                            disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                            floated="right"
                            icon
                            labelPosition="right"
                            color="blue"
                            size="small"
                            style={FiltersOnStyle}
                            onClick={() => { this.setState({ showAddForm: true }); window.scrollTo(0, 0); }}
                        ><Icon className="add" />
                            Dodavanje statusa mirovanja
                        </Button>
                    </Header>
                </div>}
                <br />

                <div>

                    {/* <h3>Statusi mirovanja</h3> */}
                    <br />
                    {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                        this.state.dataActive.length ? <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Semestar</Table.HeaderCell>
                                    <Table.HeaderCell>Broj odluke</Table.HeaderCell>
                                    <Table.HeaderCell>Datum odluke</Table.HeaderCell>
                                    <Table.HeaderCell>Datum zahtjeva</Table.HeaderCell>
                                    <Table.HeaderCell>Razlog zahtjeva</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    <Table.HeaderCell />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.dataActive.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.semesters ? el.semesters.length === 1 ? el.semesters[0].name.name + ' (' + el.semesters[0].academicYear.name + ')' : el.semesters.length === 2 ? 'zimski + ljetni semestar (' + el.semesters[0].academicYear.name + ')' : '-' : '-'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.documentNumber}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.documentDate ? moment(el.documentDate).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.date ? moment(el.date).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.reason.name}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.comment}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center">

                                            <Popup

                                                content="Izmijeni"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={(!this.props.pauseSemester && this.props.locked) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                        basic="true"
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        color="green"
                                                        onClick={() => {
                                                            localStorage.setItem('studentPauseObject', JSON.stringify(el));
                                                            this.setState({ showEditForm: true, studentPauseObject: el });
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                    </Button>}
                                            />
                                            <Popup

                                                content="Obriši"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={(!this.props.pauseSemester && this.props.locked) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.onRemoveStudentPause(el.id)}
                                                    />}
                                            />
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>
                        </Table>

                            : <div> Nema podataka o statusu mirovanja.</div>
                    }

                </div>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default StudentPauseStatus;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentPauseStatus.js